import { useTranslation } from 'react-i18next';

import type { StatusSlice } from '../../types';
import { Mono } from '@/shared/ui/atoms/Mono';
import './StatusDistribution.styl';

type Props = { slices: StatusSlice[]; total: number };

const ORDER: StatusSlice['status'][] = ['TODO', 'IN_PROGRESS', 'REVIEW', 'COMPLETED'];

/** One column per state: count, share and a tinted bar whose fill is the share. */
export function StatusDistribution({ slices, total }: Props) {
  const { t } = useTranslation();
  const byStatus = new Map(slices.map((s) => [s.status, s]));
  return (
    <div className="f-status">
      {ORDER.map((status) => {
        const s = byStatus.get(status) ?? { status, count: 0, pct: 0 };
        return (
          <div key={status} className={`f-status__col f-status__col--${status.toLowerCase()}`} title={t('insights.status.title', { label: t(`tasks.columns.${status}`), count: s.count, total })}>
            <div className="f-status__label">{t(`tasks.columns.${status}`)}</div>
            <Mono className="f-status__pct">{Math.round(s.pct)}%</Mono>
            <div className="f-status__bar" aria-hidden="true">
              <div className="f-status__fill" style={{ width: `${Math.max(2, Math.min(100, s.pct))}%` }} />
            </div>
            <div className="f-status__count">
              <Mono>{s.count}</Mono> {t('insights.status.tasks', { count: s.count })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
